const jenisOwner = [
  {
    label: "pilihan Semua",
    name: "filter_aktif",
    value: "0",
    id: "jenisOwner-1",
  },
  {
    label: "Owner aktif saja",
    name: "filter_aktif",
    value: "1",
    id: "jenisOwner-2",
  },
  {
    label: "Owner tidak aktif saja",
    name: "filter_aktif",
    value: "2",
    id: "jenisOwner-3",
  },
  {
    label: "Owner belum punya outlet",
    name: "filter_aktif",
    value: "3",
    id: "jenisOwner-4",
  },
];

export default jenisOwner;